import React, { useState, useContext, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { c as classnames } from '../../index-2586sEvh.js';
import get from 'lodash/get';
import { CoreContext } from '../../context/index.js';
import { selectIsFulfilled, selectAuthenticated } from '../../storeSelectors/user.js';
import { selectWishlists } from '../../storeSelectors/wishlist.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import { a as LOCAL_STORAGE_ADD_WISHLIST_PRODUCT } from '../../localStorage-h6SlcHvK.js';
import '../../payment-YC9H491Y.js';
import '../../index-nNbKOeeS.js';
import 'next/router';
import useShowError from '../../hooks/useShowError.js';
import useShowNotify from '../../hooks/useShowNotify.js';
import '../../product-_pRduMz7.js';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import '../../utils/currency.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import Loader from '../Loader/index.js';
import { M as ModalType } from '../../modal-6vnX5SO3.js';
import Modal from '../Modal/index.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import 'i18next';
import 'react-i18next';
import '../../index-SAqL6VZm.js';
import 'notistack';
import '../../utils/error.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import '../../cookies-l-jEMp6P.js';
import '../CircularProgress/index.js';
import '../OnlyUIRender/index.js';
import '../Modal/ModalContent/index.js';
import 'react-dom';
import '../../hooks/useAutoFocus.js';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../Modal/ModalHeader/index.js';

const WishlistButton = ({ classNameWrapper, product, childSku, selectedOptions = [], }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const [pending, setPending] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { useDispatch, useSelector, thunks: { wishlist: { addProductsToWishlist, removeProductsFromWishlist }, }, actions: { modal: { toggleModal }, }, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const isUserRequestFulfilled = useSelector(selectIsFulfilled);
    const isAuthorized = useSelector(selectAuthenticated);
    const wishlists = useSelector(selectWishlists);
    const showError = useShowError();
    const showNotify = useShowNotify();
    const isLoading = !isUserRequestFulfilled || pending;
    const wishlistProductItem = useMemo(() => {
        const wishlist = get(wishlists, [0]);
        if (!wishlist)
            return null;
        if (childSku) {
            return wishlist.items.find(itemInWishlist => itemInWishlist.child_sku === childSku);
        }
        return wishlist.items.find(itemInWishlist => !itemInWishlist.child_sku && itemInWishlist.product.sku === product.sku);
    }, [product, childSku, wishlists]);
    const isActive = !!wishlistProductItem;
    const removeProduct = async () => {
        setPending(true);
        const resultAction = await dispatch(removeProductsFromWishlist({
            wishlistId: wishlists[0].id,
            wishlistItemsIds: [wishlistProductItem === null || wishlistProductItem === void 0 ? void 0 : wishlistProductItem.id],
        }));
        if (removeProductsFromWishlist.fulfilled.match(resultAction)) {
            showNotify(t('$common.$validation.removedFromWishlist'));
        }
        else {
            showError(resultAction.payload.errorMessage);
        }
        setPending(false);
    };
    const addProduct = async () => {
        setPending(true);
        const resultAction = await dispatch(addProductsToWishlist({
            wishlistId: wishlists[0].id,
            wishlistItems: [
                {
                    sku: product.sku,
                    selected_options: selectedOptions,
                    quantity: 1,
                },
            ],
        }));
        if (addProductsToWishlist.fulfilled.match(resultAction)) {
            showNotify(t('$common.$validation.addedToWishlist'));
        }
        else {
            showError(resultAction.payload.errorMessage);
        }
        setPending(false);
    };
    const addWishlistProductToLocalStorage = () => {
        localStorage.setItem(LOCAL_STORAGE_ADD_WISHLIST_PRODUCT, JSON.stringify({ sku: product.sku, selectedOptions }));
    };
    const toggleWishlistState = async () => {
        if (!isAuthorized) {
            // For guest user pre-add product to the localStorage, to add it after login
            addWishlistProductToLocalStorage();
            dispatch(toggleModal(ModalType.Account));
            return;
        }
        if (isActive) {
            removeProduct();
        }
        else {
            addProduct();
        }
    };
    const closeModal = () => {
        setShowModal(false);
    };
    return (React.createElement("div", { className: classnames('icon-wrapper', classNameWrapper) }, isLoading ? (React.createElement(Loader, null)) : (React.createElement("div", { className: "wishlist-container" },
        React.createElement("button", { type: "button", className: classnames('wishlist-button', {
                active: isActive,
            }), onClick: toggleWishlistState, title: isActive
                ? t('$common.$labels.removeFromWishlist', { productName: product.name })
                : t('$common.$labels.addToWishlist', { productName: product.name }), "aria-label": isActive
                ? t('$common.$labels.removeFromWishlist', { productName: product.name })
                : t('$common.$labels.addToWishlist', { productName: product.name }) },
            React.createElement("i", { className: "icon icon-heart" })),
        showModal && (React.createElement(Modal, { open: showModal, onClose: closeModal, headingId: "wishlist-modal", maxWidth: "xs", enableScrollingBackground: true },
            React.createElement("p", null, t('$common.$validation.wishlistLogin'))))))));
};
var WishlistButton$1 = withProviders(WishlistButton, { translation: true, snackbar: true });

export { WishlistButton$1 as default };
//# sourceMappingURL=index.js.map
